import { combineReducers } from "redux";

import companyReducer from "./company";
import displayReducer from "./display";
import jobTypesReducer from "./jobTypes";
import planningReducer from "./planning";
import sidersReducer from "./siders";
import tasksReducer from "./tasks";

const makeRootReducer = () =>
    combineReducers({
        company: companyReducer,
        display: displayReducer,
        jobTypes: jobTypesReducer,
        planning: planningReducer,
        siders: sidersReducer,
        tasks: tasksReducer,
    });

export default makeRootReducer;
